import { makeAutoObservable } from "mobx";
import {
  deleteSpecifications,
  getSpecTitle,
  SpecificationsFilter,
  SpecificationType,
  specLoader,
  ZSpecification,
} from "src/business/specification";
import { RtStore } from "src/components/ReactiveTable/RtStore";

type Params = {
  specType: SpecificationType;
  beforeDelete?(ids: string[], names: Record<string, string>): Promise<void>;
};

export class ManagementSpecCommonListStore {
  constructor(private readonly params: Params) {
    this.tableStore = new RtStore({
      rowKey: "id",
      loader: specLoader(params.specType),
      selectionType: "checkbox",
    });
    makeAutoObservable(this);
  }

  get specType(): SpecificationType {
    return this.params.specType;
  }

  tableStore: RtStore<ZSpecification, SpecificationsFilter>;

  mode: Mode = null;

  setMode(m: Mode) {
    this.mode = m;
  }

  getReason(whatMode: Mode): string | undefined {
    switch (whatMode) {
      case "delete":
        if (this.tableStore.selectedKeys.length === 0) {
          return "Необходимо выбрать хотя бы одну строку";
        }
        break;
      default:
        break;
    }
    return undefined;
  }

  async deleteSelected() {
    const { tableStore } = this;
    const ids = tableStore.selectedKeys as string[];
    if (!ids.length) return;
    const { beforeDelete } = this.params;
    if (beforeDelete) {
      const names: Record<string, string> = {};
      ids.forEach((curId) => {
        const row = tableStore.rows.find(({ id }) => id === curId);
        if (row) names[curId] = getSpecTitle(row);
      });
      await beforeDelete(ids, names);
    }
    await deleteSpecifications(this.specType, ids);
    tableStore.setSelectedKeys([]);
    tableStore.onDataChanged();
  }
}

type Mode = "delete" | null;
